export class UserProfileModel{
  ID:number;
  userId:number;
  firstName:string;
  lastName:string;
  email:string;
  company:string;
}
